var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('VFadeTransition',[_c('router-view')],1),_c('VVersionInfo',{staticClass:"login__version-info",attrs:{"system":_vm.version.system}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }